const deviceType = IsPC() ? 'pc' : 'mobile'
const host = (process.env.NODE_ENV == 'development' || window.location.hostname.indexOf("192.") >= 0) ? 'http://172.30.1.101:9000/' : '//api-moss.17m3.com/';
const webUrl = (process.env.NODE_ENV == 'development' || window.location.hostname.indexOf("192.") >= 0) ? (location.origin + location.pathname) : 'https://www.m3guo.com/activity/202606/v-ja9oa/';
//const domain = deviceType == 'pc' ? webUrl : webUrl + 'm.html';
const buildDomain = function (url) {
  var targetFile = deviceType == 'pc' ? 'index.html' : 'm.html';
  var fullUrl = String(url || '');

  // 已经是 html 文件时直接返回，避免出现 m.htmlindex.html 这类拼接错误。
  if (/(?:index|m)\.html(?:$|[?#])/.test(fullUrl)) {
    return fullUrl;
  }

  return fullUrl.replace(/\/?$/, '/') + targetFile;
}

const domain = buildDomain(webUrl);


const activityTime = '3月26日—4月8日';

const getQueryVariable = function (variable) {
  var query = window.location.search.substring(1) || window.location.hash.substring(1);
  var vars = query.split("&");

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return '';
}

const wx_share_text = {
 title: '循音平乱 重塑巅峰 征战天下', // 分享标题
 desc: '循音平乱 重塑巅峰  6/23 新征战天下 出征装备玩法焕新！', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202606/version-zz/300.jpg', // 分享图标   
}

const issn = '10006';

const ajax_url_map = {
  login: host + 'api/login/authorize?callbackurl=' + encodeURIComponent(domain) + '&issn=' + issn,
  logout: '',
  free: host + 'api/login/kouDai', //口袋自登录验证  
  mplat: host + 'api/login/mplat', //梦平台免登录
  tips: 'https://tool.m3guo.com/api/web/m3goods/eq-item/', //tip获取
}

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const formatNum = function (val, max) {
  return Math.min(val, max);
}

const param = function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
      '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

const areaList = [{
    "id": 1,
    "name": "火烧赤壁"
  }, {
    "id": 2,
    "name": "草船借箭"
  }, {
    "id": 6,
    "name": "荆州之战"
  }, {
    "id": 7,
    "name": "青梅煮酒"
  }, {
    "id": 11,
    "name": "九伐中原"
  }, {
    "id": 16,
    "name": "怀旧服"
  }, {
    "id": 8,
    "name": "官渡之战"
  }, {
    "id": 9,
    "name": "桃园结义"
  }, {
    "id": 19,
    "name": "火凤燎原"
  }, {
    "id": 20,
    "name": "卧龙出渊"
  },
  {
    "id": 21,
    "name": "长生殿(Steam)"
  },
  {
    "id": 17,
    "name": "铜雀台(wegame1)"
  }, {
    "id": 18,
    "name": "凤仪亭(wegame2)"
  }, {
    "id": 100,
    "name": "TEST_1"
  }, {
    "id": 110,
    "name": "TEST_2"
  }
]

const queryArea = function (num) {
  var area = '未绑定';

  if (num == 1) {
    area = '火烧赤壁';
  } else if (num == 2) {
    area = '草船借箭';
  } else if (num == 6) {
    area = '荆州之战';
  } else if (num == 7) {
    area = '青梅煮酒';
  } else if (num == 8) {
    area = '官渡之战';
  } else if (num == 9) {
    area = '桃园结义';
  } else if (num == 11) {
    area = '九伐中原';
  } else if (num == 12) {
    area = '逐鹿中原';
  } else if (num == 13) {
    area = '三分天下';
  } else if (num == 16) {
    area = '怀旧服';
  } else if (num == 17) {
    area = '铜雀台';
  } else if (num == 18) {
    area = '凤仪亭';
  } else if (num == 19) {
    area = '火凤燎原';
  } else if (num == 20) {
    area = '卧龙出渊';
  } else if (num == 21) {
    area = '长生殿';
  } else if (num == 100 || num == 110) {
    area = '测试大区';
  }

  return area;
}

const share_format = function (data) {
  return data.koudai + '【' + data.shopName + '】' + data.price + ' ' + data.url;
};

const isIos = function () {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}();

const time_format = function (timestamp = 0, format = 'MM/DD/hh:mm') {
  let date = new Date(timestamp);
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1).toString().padStart(2, '0');
  let D = date.getDate().toString().padStart(2, '0');
  let h = date.getHours().toString().padStart(2, '0');
  let m = date.getMinutes().toString().padStart(2, '0');
  let s = date.getSeconds().toString().padStart(2, '0');

  return format.replace('Y', Y).replace('MM', M).replace('DD', D).replace('hh', h).replace('mm', m).replace('ss', s);
};

export default {
  ajax_url_map,
  getQueryVariable,
  domain,
  param,
  deviceType,
  areaList,
  issn,
  wx_share_text,
  queryArea,
  formatNum,
  activityTime,
  share_format,
  isIos,
  time_format,
}